import React, { useMemo } from 'react';

import { useSystem } from '@core';
import { useGetPresetData } from '@hooks';
import { ListMenu, WindowLevelMenuItem } from '@ui';
import { createWwwcPreset } from '@utils';

/**
 * Hiển thị danh sách preset user đã tạo
 */
export const ListCustomPreset = () => {
	const { commandsManager, servicesManager } = useSystem();
	const presetData = useGetPresetData(servicesManager, true);

	const items = useMemo(() => {
		const listItems = presetData.map((item) => {
			return createWwwcPreset({
				preset: {
					description: item.name,
					window: item.ww.toString(),
					level: item.wl.toString()
				},
				type: 'NORMAL',
				isVisibleShortcutKey: false
			});
		});
		return listItems;
	}, [presetData]);

	const onClick = ({ item, _selectedIndex }) => {
		commandsManager.run(item.commands);
	};

	return (
		<ListMenu
			items={items}
			renderer={WindowLevelMenuItem}
			className={'rounded-none border-none !py-0'}
			onClick={onClick}
			activeOptions={false}
		/>
	);
};